/*
 *
 * CbPortal constants
 *
 */

export const STORE_KEY = 'cbPortal';
export const ANON_USER_EMAIL = 'Guest';
export const localStorageLocation = 'cb_portals';
